"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFieldDataTaxCategory = void 0;
const core = __importStar(require("../../core"));
exports.ProductFieldDataTaxCategory = core.serialization.enum_([
    "standard-taxable",
    "standard-exempt",
    "books-religious",
    "books-textbook",
    "clothing",
    "clothing-swimwear",
    "digital-goods",
    "digital-service",
    "drugs-non-prescription",
    "drugs-prescription",
    "food-bottled-water",
    "food-candy",
    "food-groceries",
    "food-prepared",
    "food-soda",
    "food-supplements",
    "magazine-individual",
    "magazine-subscription",
    "service-admission",
    "service-advertising",
    "service-dry-cleaning",
    "service-hairdressing",
    "service-installation",
    "service-miscellaneous",
    "service-parking",
    "service-printing",
    "service-professional",
    "service-repair",
    "service-training",
]);
